import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table } from '@agconnections/grow-ui';
import { customDateFormat } from 'helpers/dateFormat';
import FormattedNumber from 'components/FormattedNumber';
import { OpenInNewIcon } from 'components/Icons';
import { getAbbreviatedUnit } from 'helpers/unitsAbbreviation';
import useOperationFlags from 'screens/Applications&WorkOrders/Hooks/useOperationFlags';
import navigateToAppliedProduct from '../../helpers/navigateToAppliedProduct';

const CropZoneAppliedProductRow = ({ product }) => {
  const history = useHistory();
  const { feApplicationsActive } = useOperationFlags();
  const [isViewButtonHovered, setIsViewButtonHovered] = useState(false);

  return (
    <Table.Row>
      <Table.Cell>
        <div>
          <div>{product?.productName}</div>
          <div className="text-xs text-neutral-60">
            {product?.productManufacturerName}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell>
        {customDateFormat(product.dateApplied, 'MMM dd, yyyy')}
      </Table.Cell>
      <Table.Cell>
        <div className="flex w-full justify-end">
          <FormattedNumber roundedTo={2}>
            {product?.totalAppliedArea}
          </FormattedNumber>{' '}
          ac
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex w-full justify-end">
          <FormattedNumber roundedTo={2}>
            {product?.applicationRate ?? 0}
          </FormattedNumber>{' '}
          {getAbbreviatedUnit(product?.applicationRateUnit)} / ac
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex w-full justify-end">
          <FormattedNumber unit="usCurrency" roundedTo={2}>
            {product?.costPerAcre?.toFixed(2) ?? 0}
          </FormattedNumber>{' '}
          / ac
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex w-full justify-end">
          <FormattedNumber unit="usCurrency" roundedTo={2}>
            {product?.totalCost ?? 0}
          </FormattedNumber>{' '}
          total
        </div>
      </Table.Cell>
      <Table.Cell>
        <button
          type="button"
          className="flex items-center gap-1 px-2 py-2 rounded cursor-pointer hover:bg-blue-10 hover:text-blue-90"
          onClick={() =>
            navigateToAppliedProduct({
              applicationId: product?.applicationId,
              taskId: product?.taskId,
              feApplicationsActive,
              history
            })
          }
          onMouseEnter={event => {
            event.stopPropagation();
            setIsViewButtonHovered(true);
          }}
          onMouseLeave={() => setIsViewButtonHovered(false)}
        >
          <OpenInNewIcon fill={isViewButtonHovered ? '#0092E4' : '#14151C'} />{' '}
          View
        </button>
      </Table.Cell>
    </Table.Row>
  );
};

CropZoneAppliedProductRow.propTypes = {
  product: PropTypes.shape({
    productName: PropTypes.string,
    productManufacturerName: PropTypes.string,
    dateApplied: PropTypes.string,
    totalAppliedArea: PropTypes.string,
    applicationRate: PropTypes.string,
    applicationRateUnit: PropTypes.string,
    costPerAcre: PropTypes.string,
    totalCost: PropTypes.string,
    applicationId: PropTypes.string,
    taskId: PropTypes.string
  }).isRequired
};

export default CropZoneAppliedProductRow;
